import React from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import StatBoxSlim from "components/Stats/StatBoxSlim";

const PhotoShootAssetTypeCommon = ({ dataPhotoShootByAsset }) => {
  const rows = Array.isArray(dataPhotoShootByAsset)
    ? dataPhotoShootByAsset.filter((row) => row.subType !== "loading")
    : [];
  const total = rows.reduce((sum, row) => sum + (Number(row.CNT) || 0), 0);

  if (rows.length === 0) {
    return <Typography variant="body2" color="textSecondary">データがありません</Typography>;
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="caption">合計：{total.toLocaleString()}</Typography>
      </Grid>
      {rows.map((row) => (
        <Grid item xs={12} sm={6} md={3} lg={2} key={`${row.type}:${row.subType}`}>
          <StatBoxSlim title={row.label || row.subType || "-"} value={row.CNT} />
        </Grid>
      ))}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  dataPhotoShootByAsset: state.pictreeCommon.dataPhotoShootByAsset,
});

export default connect(mapStateToProps)(PhotoShootAssetTypeCommon);
